import { V2ATransfer } from '@varo/graphql-schema-types';
import GetV2ATransfer from 'services/graphql/queries/MoveMoney/GetV2aTransfer';
import { CombinedError, useQuery, UseQueryExecute } from 'urql';

interface TransferHistoryOutput {
  fetching: boolean;
  refetchQuery: UseQueryExecute;
  error?: CombinedError;
  transfer?: V2ATransfer;
}

const useV2ATransfer = ({
  transferId,
}: {
  transferId: string;
}): TransferHistoryOutput => {
  const [{ data, fetching, error }, refetchQuery] = useQuery<{
    v2aTransfer: V2ATransfer;
  }>({
    query: GetV2ATransfer,
    requestPolicy: 'cache-and-network',
    variables: {
      input: {
        transferId,
      },
    },
  });

  return {
    fetching,
    error,
    transfer: data?.v2aTransfer,
    refetchQuery,
  };
};

export default useV2ATransfer;
